import { OrderValidateResponse } from 'api/order/validate';
import { APIResponse } from 'api/response';


export const isAdminValid = (response: APIResponse<OrderValidateResponse>): boolean => {
  return response.data?.eligible || false;
};
